// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3YPWb","header":"PatientQuestionnaire_header__1mb7Z","info":"PatientQuestionnaire_info__3VmA_"};